import {useMutation} from "@tanstack/react-query";

import {createServiceMutationOptions} from "./create-service.mutation-options";

export function useCreateService() {
  return useMutation(createServiceMutationOptions());
}
